import { MoneySchema } from "@redotech/money";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getRescuePanelAttribution = {
  name: "getRescuePanelAttribution" as const,
  input: z.object({
    /**
     * Optional window. Both bounds are required when present so a half-open
     * range can't be expressed.
     */
    dateRange: z
      .object({ start: zExt.instant(), end: zExt.instant() })
      .optional(),
  }),
  output: z.object({
    revenueFromPanel: MoneySchema,
    numImpressions: z.number(),
    numEngagements: z.number(),
    numOrders: z.number(),
    conversionRate: z.number(),
    conversionRateChangeComparedToPreviousPeriod: z.number().nullable(),
  }),
};
